import { Flex, Select, Text } from "@chakra-ui/react";
import { forwardRef } from "react";

const SelectUsage = ({ label, value, setClick, onBlur, ...rest }, ref) => {
  return (
    <Flex align="center">
      <Text as="p" color="#1A8AB6" fontWeight={"bold"}>
        {label}
      </Text>
      <Select
        {...rest}
        width={rest.width ? rest.width : "fit-content"}
        border="none"
        bg="#ebebeb"
        outline="none"
        _focus={{
          outline: "none",
          boxShadow: "none",
        }}
        fontSize="12px"
        height="fit-content"
        onClick={setClick}
        onBlur={onBlur}
        ref={ref}
      >
        <option aria-label="None" value="" />
        {value.map((item) => (
          <option
            key={item}
            value={item}
            style={{
              fontSize: "16px",
              width: "fit-content",
            }}
          >
            {item}
          </option>
        ))}
      </Select>
    </Flex>
  );
};

export default forwardRef(SelectUsage);
